/*
 * @Description: 服务系统二维码配置
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2025-11-18
 */

export const SERVICE_CODE_BASE_URL = 'https://materialdb.zhaoyl.com/fed/cowork/service-code/'

export type ServiceCode = 'reneval' | 'report' | 'meiye-v2' | 'np' | 'amz' | 'amzen' | 'npen' | 'touke' | 'dssc' | 'tkapp' | 'rpt' | 'ct'

export const SERVICE_CODE_URLS: Record<ServiceCode, string> = {
  // 续费
  'reneval': `${SERVICE_CODE_BASE_URL}reneval.png?t=${Date.now()}`,
  // 报告和咨询
  'report': `${SERVICE_CODE_BASE_URL}report.png?t=${Date.now()}`,
  // 美业数据大脑
  'meiye-v2': `${SERVICE_CODE_BASE_URL}meiye-v2.png?t=${Date.now()}`,
  // 新品
  'np': `${SERVICE_CODE_BASE_URL}np.png?t=${Date.now()}`,
  // 亚马逊数据洞察
  'amz': `${SERVICE_CODE_BASE_URL}amz.png?t=${Date.now()}`,
  // 亚马逊数据洞察英文版
  'amzen': `${SERVICE_CODE_BASE_URL}amzen.png?t=${Date.now()}`,
  'npen': `${SERVICE_CODE_BASE_URL}npen.png?t=${Date.now()}`,
  'touke': `${SERVICE_CODE_BASE_URL}touke.png?t=${Date.now()}`,
  'dssc': `${SERVICE_CODE_BASE_URL}dssc.png?t=${Date.now()}`,
  'tkapp': `${SERVICE_CODE_BASE_URL}tkapp.png?t=${Date.now()}`,
  'rpt': `${SERVICE_CODE_BASE_URL}rpt-qrcode.jpg?t=${Date.now()}`,
  // 智能宣称工具
  'ct': `${SERVICE_CODE_BASE_URL}ct.jpg?t=${Date.now()}`,
}

